import { getMapOffers } from '../../utils/offers';
import { ICalculatorMcfValues } from '../../types/features';
import { useDispatch, useSelector } from 'react-redux';
import { selectUtmTags } from '../../selectors/landing';
import { setActionUrl, setFinancePlatformEnabled, setOffersLength } from '../../redux/landingSlice';
import { landingApi } from '../../api';
import { IGetAvailableMultiOffersRequestV2 } from '../../repositories/mortgage-broker-calculator/entities/get_avaiable_multi_offers_v2/GetAvailableMultiOffersRequestV2';
import { useEffect } from 'react';

export const useGetMappedOffers = (calculatorValues: ICalculatorMcfValues) => {
  const dispatch = useDispatch();
  const requestObject = {
    regionId: Number(calculatorValues.regionId),
    loanTermYears: Number(calculatorValues.loanTerm),
    objectCost: calculatorValues.objectCost,
    downPayment: calculatorValues.downPayment,
    incomeConfirmation: calculatorValues.incomeConfirm,
    realEstateType: calculatorValues.realEstateType,
    objectType: calculatorValues.objectType,
    benefitProgram: calculatorValues.benefitProgram,
    employmentType: calculatorValues.typeOfEmployment,
    payrollBankId: Number(calculatorValues.payrollBank),
    lifeInsurance: calculatorValues.lifeInsurance,
  } as unknown as IGetAvailableMultiOffersRequestV2;

  const { data, isFetching } = landingApi.endpoints.getOfferListingV2.useQuery(requestObject);

  const utmTags = useSelector(selectUtmTags);

  const mappedOffers = data && data.offers ? getMapOffers(data.offers, utmTags) : [];

  // Переносим dispatch вызовы в useEffect, чтобы избежать обновления состояния во время рендеринга
  useEffect(() => {
    if (data && 'actionUrl' in data) {
      dispatch(setActionUrl(data.actionUrl as string));
    }

    if (data && data.meta) {
      dispatch(setFinancePlatformEnabled(data.meta.financePlatformEnabled));
    }

    if (mappedOffers.length > 0) {
      dispatch(setOffersLength(mappedOffers.length));
    } else {
      dispatch(setOffersLength(null));
    }
  }, [data, mappedOffers.length, dispatch]);

  return { mappedOffers, isFetching };
};
